import { render, staticRenderFns } from "./PreorderProductsTable.vue?vue&type=template&id=0ad990a8&"
import script from "./PreorderProductsTable.vue?vue&type=script&lang=ts&"
export * from "./PreorderProductsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports